var mobyMenu = new Moby({ 
    menu:$("#moby-mobile-menu"),
    mobyTrigger:$("#burger-btn"),
    menuClass:"left-side",
    enableEscape: true,
    subMenuOpenIcon:'<i class="fa fa-caret-down"></i>',
    subMenuCloseIcon:'<i class="fa fa-caret-up"></i>',
    template:'<div class="moby-close"><span class="moby-close-icon"></span></div><div class="moby-wrap"><div class="moby-menu"></div></div>'
});